'use strict'

class AccessDeniedError extends Error {
    constructor(message) {
        super(message || 'Access denied')
        this.statusCode = 403
    }
}

module.exports = {
    AccessDeniedError
}



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/error.js
// module id = 294
// module chunks = 51